/**
 * Global loading modal policy (reversible via .env).
 *
 * Default: GET requests do NOT show the full-screen modal.
 * Mutations (POST/PUT/PATCH/DELETE) still use it.
 *
 * Rollback: set REACT_APP_GLOBAL_LOADING_ON_GET=true in .env and restart dev server.
 */
export const GLOBAL_LOADING_ON_GET = process.env.REACT_APP_GLOBAL_LOADING_ON_GET === 'true'

export const MUTATION_LOADING_MESSAGE = 'جاري تنفيذ العملية...'
